import React, { FC } from 'react';
import styled from 'styled-components';

const StyledSelect = styled.select`
    mix-blend-mode: normal;
    color: #263238;
    background-color: white;
    padding: 4px 20px;
    border-width: 1px;
    border-color: #e5e7eb;
    border-radius: 6px;
    border-style: solid;
    font-family: ${(props) => props.theme.app.font};
    font-size: 13px;
    font-weight: normal;
    font-style: normal;
    text-align: left;
    text-align-last: left;
    height: 28px;
    width: 100%;
`;

interface _SelectProps {
    className?: string;
    name?: string;
    value?: string | number | string[];
    multiple?: boolean;
    onChange?: (value: string) => void;
    source?: { [k: string]: string };
    children?: React.ReactNode;
    onBlur?: (value: string) => void;
    disabled?: boolean;
}

const _Select: FC<_SelectProps> = (props) => {
    const handleChange = (event: { target: any }) => {
        if (props.onChange) props.onChange(event.target.value);
    };
    const handleOnBlur = (event: { target: any }) => {
        if (props.onBlur) props.onBlur(event.target.value);
    };

    return (
        <StyledSelect
            disabled={props.disabled ? true : false}
            multiple={props.multiple ? true : false}
            className={props.className}
            name={props.name}
            onChange={handleChange}
            value={props.value}
            onBlur={handleOnBlur}
        >
            {props.children}
        </StyledSelect>
    );
};

export const Select = styled(_Select)``;
